const healthera = {
  50: '#2F9D6D',
  100: '#2F9D6D',
  200: '#2F9D6D',
  300: '#2F9D6D',
  400: '#2F9D6D',
  500: '#2F9D6D',
  600: '#2F9D6D',
  700: '#2F9D6D',
  800: '#2F9D6D',
  900: '#2F9D6D',
  A100: '#2F9D6D',
  A200: '#2F9D6D',
  A400: '#2F9D6D',
  A700: '#2F9D6D',
  contrastDefaultColor: 'light',
};

export default healthera;
